if (!customElements.get('lyss-poster')) {
  customElements.define('lyss-poster', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.config = JSON.parse(this.querySelector('[data-lyss-config]').textContent);
      this.variants = this.config.variants;
      this.variant = this.variants.find(v => String(v.id) === String(this.config.selected)) || this.variants.find(v => v.available) || this.variants[0];
      this.unit = 'cm';
      this.busy = false;
      this.form = this.querySelector('form');
      this.select = this.querySelector('[name="id"]');
      this.mainAdd = this.querySelector('.lyss-main-add');
      this.sticky = this.querySelector('.lyss-sticky-cart');
      this.buttons = [...this.querySelectorAll('.lyss-add')];
      this.querySelector('.lyss-enhanced-options').hidden = false;
      this.classList.add('is-enhanced');
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled || this.busy) return;
        if (button.dataset.image) this.photo(button.dataset.image);
        if (button.dataset.galleryStep) {
          const thumbs = [...this.querySelectorAll('[data-image]')];
          const current = Math.max(0, thumbs.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
          if (thumbs.length) this.photo(thumbs[(current + Number(button.dataset.galleryStep) + thumbs.length) % thumbs.length].dataset.image);
        }
        if (button.dataset.style) {
          const choices = this.variants.filter(v => v.style === button.dataset.style);
          this.variant = choices.find(v => v.size === this.variant?.size && v.available) || choices.find(v => v.available) || choices[0];
          this.render(true);
        }
        if (button.dataset.size) {
          this.variant = this.variants.find(v => v.style === this.variant.style && v.size === button.dataset.size && v.available) || this.variants.find(v => v.size === button.dataset.size && v.available) || this.variant;
          this.render(true);
        }
        if (button.dataset.unit) { this.unit = button.dataset.unit; this.render(); }
        if (button.classList.contains('lyss-sticky-add')) this.form.requestSubmit(this.mainAdd);
      }, {signal});
      this.form.addEventListener('submit', event => this.addToCart(event), {signal});
      window.addEventListener('scroll', () => this.updateSticky(), {passive:true, signal});
      window.addEventListener('resize', () => this.updateSticky(), {signal});
      window.addEventListener('popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const next = this.variants.find(v => String(v.id) === id);
        if (next) { this.variant = next; this.render(); }
      }, {signal});
      this.observer = new ResizeObserver(() => this.updateSticky());
      this.observer.observe(this);
      const selectedId = new URL(window.location.href).searchParams.get('variant');
      const selectedVariant = this.variants.find(v => String(v.id) === selectedId);
      if (selectedVariant) this.variant = selectedVariant;
      this.photo('room');
      this.render();
      this.updateSticky();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
    photo(key) {
      const thumb = [...this.querySelectorAll('[data-image]')].find(b => b.dataset.image === key);
      if (!thumb) return;
      const hero = this.querySelector('.lyss-hero');
      hero.removeAttribute('srcset');
      hero.src = thumb.dataset.src;
      hero.alt = thumb.dataset.alt;
      hero.style.objectFit = 'contain';
      this.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b === thumb)));
    }
    photoStyle(style) {
      const thumb = [...this.querySelectorAll('[data-photo-style]')].find(b => b.dataset.photoStyle === style);
      if (thumb) this.photo(thumb.dataset.image);
    }
    selection(variant = this.variant) {
      if (!variant) return '';
      return variant.style + ' · ' + variant.size + ' · ' + variant[this.unit] + ' ' + this.unit;
    }
    render(updateUrl = false) {
      const v = this.variant;
      const available = Boolean(v?.available);
      this.querySelectorAll('[data-style]').forEach(b => {
        b.setAttribute('aria-pressed', String(b.dataset.style === v?.style));
        b.disabled = this.busy;
      });
      this.querySelectorAll('[data-unit]').forEach(b => {
        b.setAttribute('aria-pressed', String(b.dataset.unit === this.unit));
        b.disabled = this.busy;
      });
      this.querySelectorAll('[data-size]').forEach(b => {
        const size = b.dataset.size;
        const match = this.variants.find(x => x.style === v?.style && x.size === size);
        const reference = match || this.variants.find(x => x.size === size);
        const dimensions = (reference?.[this.unit] || this.config.dimensions[this.unit][size]) + ' ' + this.unit;
        b.querySelector('.lyss-size-measurement').textContent = dimensions;
        const alternative = this.variants.find(x => x.size === size && x.available);
        b.disabled = !alternative || this.busy;
        b.classList.toggle('is-other-color', !match?.available && Boolean(alternative));
        b.setAttribute('aria-pressed', String(size === v?.size));
        b.setAttribute('aria-label', b.querySelector('.lyss-size-name').textContent + ' · ' + dimensions + (!match?.available ? ' · ' + (alternative ? (alternative.style === 'Original' ? this.config.strings.white : alternative.style) : this.config.strings.soldOut) : ''));
      });
      this.select.value = v ? String(v.id) : '';
      this.buttons.forEach(b => { b.disabled = !available || this.busy; b.setAttribute('aria-busy', String(this.busy)); });
      this.querySelectorAll('[data-add-label]').forEach(el => el.textContent = this.busy ? this.config.strings.adding : available ? this.config.strings.add : this.config.strings.soldOut);
      this.querySelectorAll('[data-price]').forEach(el => el.textContent = v?.price || '');
      this.querySelector('.lyss-sticky-selection').textContent = this.selection() + ' · ' + this.config.strings.unframed;
      if (updateUrl && v) {
        const url = new URL(window.location.href);
        url.pathname = v.url;
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
        this.showStatus('');
      }
    }
    showStatus(message, success = false) {
      this.querySelectorAll('[data-status]').forEach(el => el.textContent = message);
      this.querySelectorAll('.lyss-cart-link').forEach(el => el.hidden = !success);
    }
    updateSticky() {
      const visible = window.matchMedia('(max-width:700px)').matches && this.mainAdd.getBoundingClientRect().bottom <= 0;
      this.sticky.classList.toggle('is-visible', visible);
      this.sticky.setAttribute('aria-hidden', String(!visible));
      this.sticky.inert = !visible;
      this.style.setProperty('--lyss-sticky-height', visible ? this.sticky.offsetHeight + 'px' : '0px');
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.variant?.available) return;
      const selected = this.variant;
      const selection = this.selection(selected);
      this.busy = true;
      this.showStatus('');
      this.render();
      const root = (window.Shopify?.routes?.root || this.config.root).replace(/\/?$/, '/');
      let added = false;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items:[{id:selected.id, quantity:1}]}), signal:this.controller.signal
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.config.strings.error);
        added = true;
        this.showStatus(this.config.strings.added + ': ' + selection, true);
      } catch (error) {
        if (error.name !== 'AbortError') this.showStatus(error.message || this.config.strings.error);
      } finally {
        this.busy = false;
        if (this.isConnected) { this.render(); this.updateSticky(); }
      }
      if (added && this.isConnected) {
        try {
          const response = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}, signal:this.controller.signal});
          if (!response.ok) return;
          const cart = await response.json();
          document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
          const badgeResponse = await fetch(root + '?sections=cart-icon-bubble', {signal:this.controller.signal});
          if (badgeResponse.ok) {
            const sections = await badgeResponse.json();
            const badge = document.getElementById('cart-icon-bubble');
            if (badge && sections['cart-icon-bubble']) badge.innerHTML = sections['cart-icon-bubble'];
          }
        } catch (_) {}
      }
    }
  });
}


